import styled from "styled-components";

export const DropDown = styled.select`
  border-style: solid;
  border-color #56565b;
  border-width: 0px 0px 2px 0px;
  width: 100%;
`;
